import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface GlobalNavMenuEntityParams {
  label: string;
}
export class GlobalNavMenuEntity extends BaseEntityClass {
  label: string;
  constructor(params: GlobalNavMenuEntityParams) {
    super();
    this.type = "global_nav_menu";
    this.entity_version = 1;
    this.label = params.label;
  }
}
